//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function signPdf(pdf?: Types.FileParameter | undefined, reason?: string | null | undefined, appearance_PositionX?: number | undefined, appearance_PositionY?: number | undefined, appearance_Height?: number | undefined, appearance_Width?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/Pdf/sign";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (pdf === null || pdf === undefined)
        throw new Error("The parameter 'pdf' cannot be null.");
    else
        content_.append("Pdf", pdf.data, pdf.fileName ? pdf.fileName : "Pdf");
    if (reason !== null && reason !== undefined)
        content_.append("Reason", reason.toString());
    if (appearance_PositionX === null || appearance_PositionX === undefined)
        throw new Error("The parameter 'appearance_PositionX' cannot be null.");
    else
        content_.append("Appearance.PositionX", appearance_PositionX.toString());
    if (appearance_PositionY === null || appearance_PositionY === undefined)
        throw new Error("The parameter 'appearance_PositionY' cannot be null.");
    else
        content_.append("Appearance.PositionY", appearance_PositionY.toString());
    if (appearance_Height === null || appearance_Height === undefined)
        throw new Error("The parameter 'appearance_Height' cannot be null.");
    else
        content_.append("Appearance.Height", appearance_Height.toString());
    if (appearance_Width === null || appearance_Width === undefined)
        throw new Error("The parameter 'appearance_Width' cannot be null.");
    else
        content_.append("Appearance.Width", appearance_Width.toString());

    let options_: AxiosRequestConfig = {
        ..._requestConfigSignPdf,
        ...config,
        data: content_,
        responseType: "blob",
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/octet-stream"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSignPdf(_response);
    });
}

function processSignPdf(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

export function validatePdf(pdf?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ValidatePdfResponseDto[]> {
    let url_ = getBaseUrl() + "/api/Pdf/validate";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (pdf !== null && pdf !== undefined)
        content_.append("Pdf", pdf.data, pdf.fileName ? pdf.fileName : "Pdf");

    let options_: AxiosRequestConfig = {
        ..._requestConfigValidatePdf,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processValidatePdf(_response);
    });
}

function processValidatePdf(response: AxiosResponse): Promise<Types.ValidatePdfResponseDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.ValidatePdfResponseDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.ValidatePdfResponseDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ValidatePdfResponseDto[]>(null as any);
}
let _requestConfigSignPdf: Partial<AxiosRequestConfig> | null;
export function getSignPdfRequestConfig() {
  return _requestConfigSignPdf;
}
export function setSignPdfRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSignPdf = value;
}
export function patchSignPdfRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSignPdf = patch(_requestConfigSignPdf ?? {});
}

let _requestConfigValidatePdf: Partial<AxiosRequestConfig> | null;
export function getValidatePdfRequestConfig() {
  return _requestConfigValidatePdf;
}
export function setValidatePdfRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigValidatePdf = value;
}
export function patchValidatePdfRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigValidatePdf = patch(_requestConfigValidatePdf ?? {});
}